/**
 * AdminEspecializadoSidebar — Sidebar enxuta para admins especializados de diligência.
 *
 * Apenas 3 itens operacionais: Visão Geral, Fila da Área, Documentos da Área.
 */

import React from 'react';
import {
  LayoutDashboard,
  FileText,
  FolderOpen,
} from 'lucide-react';
import { BaseSidebar, NavigationItem } from './BaseSidebar';
import { useDiligenciaPermissions } from '@/features/diligencias/hooks';
import { getEspecialidadeConfig } from '@/utils/adminEspecializadoConfig';

interface AdminEspecializadoSidebarProps {
  onSidebarToggle?: (open: boolean) => void;
}

export const AdminEspecializadoSidebar: React.FC<AdminEspecializadoSidebarProps> = ({
  onSidebarToggle,
}) => {
  const { especialidade } = useDiligenciaPermissions();
  const config = getEspecialidadeConfig(especialidade);

  const navigationItems: NavigationItem[] = [
    {
      label: 'Visão Geral',
      href: '/admin/dashboard',
      icon: <LayoutDashboard className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: config?.filaNome ?? 'Fila da Área',
      href: '/admin/diligencias',
      icon: <FileText className="text-sidebar-foreground size-4 shrink-0" />,
    },
    {
      label: config?.documentosTitulo ?? 'Documentos',
      href: '/admin/documentos-diligencia',
      icon: <FolderOpen className="text-sidebar-foreground size-4 shrink-0" />,
    },
  ];

  return (
    <BaseSidebar
      navigationItems={navigationItems}
      profilePath="/admin/profile"
      onSidebarToggle={onSidebarToggle}
    />
  );
};
